import React from 'react';
import { string } from 'yup';
import { EMPLOYEE_ROLE } from 'containers/User/constants.js';
import MDEditor from 'components/interaction/MDEditor/index.jsx';
import SelectRecipients from 'components/interaction/SelectRecipients/index.jsx';
import Attachments from 'components/interaction/AddFiles/Attachments.jsx';
import SelectButtons from '../../../PhotoBook/AlbumSettings/SelectButtons/index.jsx';
import { CONVERSATION_MAX_LENGTH, typeOptions } from '../../constants.jsx';
import messages from '../../messages.js';
import OwnLanguagePrompt from '../../OwnLanguagePrompt.jsx';

function getSchema(values, options) {
  const { onPopup, onCancel, typeDisabled, defaultRole, setDefaultRole, inboxId, roles } = options;
  const showType = values.participants?.filter((p) => p.roleType !== EMPLOYEE_ROLE).length > 1;
  const bodyRequired = !(values.files && Object.values(values.files).some((a) => a.length > 0));

  return {
    id: 'conversations',
    properties: [
      {
        id: 'participants',
        as: SelectRecipients,
        attributes: { prompt: messages.selectParticipants, roles, inboxId, onPopup, onCancel, defaultRole, setDefaultRole },
        required: true,
      },
      showType && {
        id: 'topicType',
        as: SelectButtons,
        attributes: { options: typeOptions, disabled: typeDisabled },
        required: true,
      },
      {
        id: 'title',
        type: 'text',
        placeholder: messages.subject,
        required: true,
        attributes: { emoji: true },
      },
      {
        id: 'body',
        as: MDEditor,
        placeholder: messages.message,
        help: <OwnLanguagePrompt className="mx-3 mb-2" />,
        attributes: { maxLength: CONVERSATION_MAX_LENGTH },
        required: bodyRequired,
        schema: bodyRequired ? string().required() : string().nullable(),

      },
      {
        id: 'files',
        as: Attachments,
        required: !values.body,
      },
    ].filter(Boolean),
  };
}

export default getSchema;
